/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BomsTable_itemEdges$ref: FragmentReference;
declare export opaque type BomsTable_itemEdges$fragmentType: BomsTable_itemEdges$ref;
export type BomsTable_itemEdges = $ReadOnlyArray<{|
  +node: {|
    +id: string,
    +bomNumber: ?string,
    +itemNumber: string,
    +partNumber: ?string,
    +name: string,
    +description: ?string,
    +bomComponentCount: ?number,
  |},
  +$refType: BomsTable_itemEdges$ref,
|}>;
export type BomsTable_itemEdges$data = BomsTable_itemEdges;
export type BomsTable_itemEdges$key = {
  +$data?: BomsTable_itemEdges$data,
  +$fragmentRefs: BomsTable_itemEdges$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BomsTable_itemEdges",
  "type": "ItemEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "bomNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "itemNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "partNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "bomComponentCount",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5699dd5662e7fb614d32d8143e025fe8';
module.exports = node;
